<ion-header mode="md">
  <ion-toolbar class="ion-text-center">
    <ion-item lines="none">
      <ion-img class="logo" src="../assets/images/app-logo.svg"></ion-img>
    </ion-item>
  </ion-toolbar>
</ion-header>
<ion-content full>
  <ion-grid class="box">
    <ion-row class="content-padding-vertical">
      <ion-col>
        <ion-item class="input" lines="none">
          <ion-back-button defaultHref="/auth" text=""></ion-back-button>
          <h3>{{ "RESET_PASSWORD.HEADER" | translate}}</h3>
        </ion-item>

        <ion-grid *ngIf="!keyValid" class="no-padding-row-grid">
          <ion-row class="ion-text-center">
            <ion-col class="no-padding">
              <ion-label lines="none">
                <ion-icon name="close-outline" class="error"></ion-icon>
              </ion-label>
            </ion-col>
          </ion-row>
          <ion-row class="ion-justify-content-center">
            <ion-col>
              <ion-label>
                {{ "RESET_PASSWORD.PASSWORD_CHANGED" | translate}}
              </ion-label>
            </ion-col>
          </ion-row>
        </ion-grid>

        <div *ngIf="!sended && keyValid">
          <p>{{ "RESET_PASSWORD.FORGOT_PASSWORD" | translate}}</p>

          <form [formGroup]="form">
            <app-input
              [type]="passwordEye ? 'text' : 'password'"
              [form]="form"
              formControlName="password"
              label="RESET_PASSWORD.NEW_PASSWORD"
              [showPasswordEye]="true"
              [(passwordEye)]="passwordEye"
              [submittedError]="validationError"
            ></app-input>

            <app-input
              [type]="passwordEye ? 'text' : 'password'"
              [form]="form"
              formControlName="rePassword"
              label="RESET_PASSWORD.CONFIRM_NEW_PASSWORD"
              [showPasswordEye]="true"
              [(passwordEye)]="passwordEye"
              [submittedError]="validationError"
            ></app-input>

            <ion-button
              class="reset-password-button"
              (click)="save()"
              size="large"
              expand="block"
              >{{ "RESET_PASSWORD.CHANGE_PASSWORD" | translate}}</ion-button
            >
          </form>
        </div>
        <ion-grid *ngIf="sended && keyValid" class="no-padding-row-grid">
          <ion-row class="ion-text-center">
            <ion-col class="no-padding">
              <ion-label lines="none">
                <ion-icon name="checkmark-outline" class="ok"></ion-icon>
              </ion-label>
            </ion-col>
          </ion-row>
          <ion-row class="ion-justify-content-center">
            <ion-col>
              <ion-label>
                {{ "RESET_PASSWORD.PASSWORD_CHANGE_SUCCESS" | translate}}
              </ion-label>
            </ion-col>
          </ion-row>
          <ion-row class="ion-justify-content-center">
            <ion-col>
              <ion-label>
                <ion-button
                  class="confirm-register-button"
                  routerLink="/auth"
                  size="large"
                  expand="block"
                >
                  {{ "CONFIRM_REGISTER.LOGIN_BUTTON" | translate }}
                </ion-button>
              </ion-label>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
